import { FunctionalComponent, h } from 'preact';
import { useContext } from 'preact/hooks';
import { ToastServiceContext } from './toast-service-provider';
import { getIconByToastType } from './get-icon-by-toast-type';

import './toast.scss';

type ToastProps = {
  className?: string;
};

export const Toast: FunctionalComponent<ToastProps> = ({ className = '' }) => {
  const { activeToast } = useContext(ToastServiceContext);

  if (!activeToast) {
    return null;
  }

  return (
    <div className={`uw-toast uw-toast--${activeToast.type} ${className}`} role="alert">
      <span className="uw-toast__icon">
        <img
          role="none"
          alt=""
          src={`./frontend/images/${getIconByToastType(activeToast.type)}.svg`}
        />
      </span>
      <p className="uw-toast__message">{activeToast.text}</p>
    </div>
  );
};
